import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { navigationLinks } from '../data/navigationData';

const categoryMap = {
  'om-skolen': {
    title: 'Om skolen',
    subtitle: 'Historie, værdier, medarbejdere, bestyrelse og vedtægter',
    desc: 'Læs om friskolens grundlag, forældredrevne engagement og mød de dygtige mennesker, der skaber skolen i hverdagen.',
    image: 'https://assets.auxodev.dk/cdn-cgi/image/width=1000,quality=80,format=auto/assets/7e157867-df92-46f8-b5ca-20179d4d9044/dsc-7245.jpg',
    navTitle: 'Om skolen'
  },
  'saadan-goer-vi': {
    title: 'Sådan gør vi',
    subtitle: 'Politikker, evaluering, fælles mål, klasser, traditioner og tilsyn',
    desc: 'Se hvordan hverdagen og undervisningen er struktureret på Odder Lille Friskole fra 0. til 9. klasse.',
    image: 'https://assets.auxodev.dk/cdn-cgi/image/width=1000,quality=80,format=auto/assets/7e157867-df92-46f8-b5ca-20179d4d9044/2.jpg',
    navTitle: 'Sådan gør vi'
  },
  'paa-olf': {
    title: 'På OLF',
    subtitle: 'Elever, udlandsrejse, forældresamarbejde og traditioner',
    desc: 'Alt om livet på skolen – elevernes hverdag, 9. klasses 12-dages udlandsrejse og det tætte forældrefællesskab.',
    image: 'https://assets.auxodev.dk/cdn-cgi/image/width=1000,quality=80,format=auto/assets/7e157867-df92-46f8-b5ca-20179d4d9044/3.jpg',
    navTitle: 'På OLF'
  },
  'ny-paa-skolen': {
    title: 'Ny på skolen',
    subtitle: 'Værdier, optagelse, besøg og opskrivning',
    desc: 'Er du nysgerrig på, hvad Odder Lille Friskole kan tilbyde dit barn? Find alt hvad du behøver som kommende forælder her.',
    image: 'https://assets.auxodev.dk/cdn-cgi/image/width=1000,quality=80,format=auto/assets/7e157867-df92-46f8-b5ca-20179d4d9044/odder-friskole-hero-happy-kids.jpg',
    navTitle: 'Om skolen'
  },
  'hverdagen': {
    title: 'Hverdagen',
    subtitle: 'Undervisning, Fritteren, musik, traditioner og gallerier',
    desc: 'Oplev hvordan en skoledag på Odder Lille Friskole folder sig ud med faglig fordybelse, kreativitet og stærkt fællesskab.',
    image: 'https://assets.auxodev.dk/cdn-cgi/image/width=1000,quality=80,format=auto/assets/7e157867-df92-46f8-b5ca-20179d4d9044/2.jpg',
    navTitle: 'Sådan gør vi'
  },
  'praktisk-info': {
    title: 'Praktisk information',
    subtitle: 'Mødetider, skolepenge, tilsynsrapporter og vedtægter',
    desc: 'Find alle formelle og praktiske informationer, dokumenter og rapporter for nuværende og kommende forældre.',
    image: 'https://assets.auxodev.dk/cdn-cgi/image/width=1000,quality=80,format=auto/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf8.jpg',
    navTitle: 'Sådan gør vi'
  }
};

export default function CategoryPage() {
  const { categorySlug } = useParams();
  const info = categoryMap[categorySlug] || {
    title: 'Oversigt',
    subtitle: 'Indholdsoversigt',
    desc: 'Vælg en underside herunder.',
    image: 'https://assets.auxodev.dk/cdn-cgi/image/width=1000,quality=80,format=auto/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf10.jpg',
    navTitle: ''
  };

  const navItem = navigationLinks.find(
    (item) => item.title === info.navTitle || item.href === `/${categorySlug}`
  ) || {
    children: []
  };

  return (
    <div className="bg-white pb-20">
      
      {/* Header Banner following container line */}
      <section className="bg-[#eef4e6] border-b border-[#d9e5d4] py-12 lg:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl space-y-4">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1D2923] tracking-tight font-serif-heading">
              {info.title}
            </h1>
            <p className="text-base sm:text-lg text-[#5A6961] leading-relaxed">
              {info.desc}
            </p>
          </div>
        </div>
      </section>

      {/* Subpage Grid following container line */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 lg:pt-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {navItem.children && navItem.children.map((child) => (
            <Link
              key={child.href}
              to={child.href}
              className="group bg-white p-7 rounded-3xl border border-[#d9e5d4] shadow-xs hover:shadow-lg hover:border-[#88A68E] transition-all duration-300 flex flex-col justify-between"
            >
              <div className="space-y-3">
                <div className="w-12 h-12 rounded-2xl bg-[#eef4e6] flex items-center justify-center text-[#264A35] text-xl group-hover:bg-[#264A35] group-hover:text-white transition-colors duration-300">
                  <i className="fa-solid fa-arrow-right-long text-sm group-hover:translate-x-0.5 transition-transform" aria-hidden="true" />
                </div>
                <h2 className="text-xl font-bold text-[#1D2923] font-serif-heading group-hover:text-[#264A35] transition-colors">
                  {child.title}
                </h2>
                {child.desc && (
                  <p className="text-sm text-[#5A6961] leading-relaxed">
                    {child.desc}
                  </p>
                )}
              </div>

              <div className="pt-6 mt-6 border-t border-[#d9e5d4] flex items-center justify-between text-xs font-bold text-[#264A35]">
                <span>Læs mere</span>
                <i className="fa-solid fa-chevron-right text-[10px] group-hover:translate-x-1 transition-transform" aria-hidden="true" />
              </div>
            </Link>
          ))}
        </div>
      </section>

    </div>
  );
}
